import type { BankCollateralStockItem } from '../types/report';

export const bankCollateralRowKey = (item: BankCollateralStockItem): string =>
  String(item.item_id);

export interface BankCollateralTotals {
  count: number;
  eligibleQty: number;
  extendedCost: number;
  extendedRetail: number;
  grossMargin: number;
}

export const computeBankCollateralTotals = (
  rows: BankCollateralStockItem[]
): BankCollateralTotals => {
  let eligibleQty = 0;
  let extendedCost = 0;
  let extendedRetail = 0;
  let grossMargin = 0;
  for (const row of rows) {
    eligibleQty += parseFloat(row.eligible_qty) || 0;
    extendedCost += parseFloat(row.extended_cost) || 0;
    extendedRetail += parseFloat(row.extended_retail) || 0;
    grossMargin += parseFloat(row.gross_margin) || 0;
  }
  return {
    count: rows.length,
    eligibleQty,
    extendedCost,
    extendedRetail,
    grossMargin,
  };
};
